module.exports = __webpack_public_path__ + "media/images/dashboard-sustainability-7b17346b.png";